import api from '@/api/index'

const bookingApi = {
  async create (payload) {
    const path = '/v2/booking'
    const method = 'post'
    const response = await api.asyncRequest(path, method, payload)
    return response.data
  }
}

export default bookingApi
